export default "__VITE_ASSET__BozVc7Wh__"